import { gql } from "@apollo/client";
import {
    CONSOLIDATION_BAG_DETAIL_FIELDS,
    CONSOLIDATION_TASK_INFO_FIELDS,
    ConsolidationBagDetail,
    ConsolidationTaskInfo,
    ConsolidationTaskStatistics,
    ROUTE_STATISTICS_FIELDS
} from "../types/ConsolidationTypes";

export const GET_CONSOLIDATION_TASK_DETAIL = gql`
    query GetConsolidationTaskDetail($taskId: String!, $warehouseId: Long!) {
        getConsolidationTaskDetails(taskId: $taskId, warehouseId: $warehouseId) {
            taskInfo {
                ...ConsolidationTaskInfoFields
            }
            bags {
                ...ConsolidationBagDetailFields
            }
            statistics {
                totalBagCount
                totalParcelCount
                shippedBagCount
                routeBreakdown {
                    ...RouteStatisticsFields
                }
            }
        }
    }
    ${CONSOLIDATION_TASK_INFO_FIELDS}
    ${CONSOLIDATION_BAG_DETAIL_FIELDS}
    ${ROUTE_STATISTICS_FIELDS}
`;

export interface GetConsolidationTaskDetailVariables {
    taskId: string;
    warehouseId: string;
}

export interface GetConsolidationTaskDetailResponse {
    getConsolidationTaskDetails: {
        taskInfo: ConsolidationTaskInfo;
        bags: ConsolidationBagDetail[];
        statistics: ConsolidationTaskStatistics;
    };
}